export default __webpack_public_path__ + "static/media/checkbox-blue-checked.2450a67b.svg";